import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom"
import { useApi } from "../../../api";
import { ErrorDialog } from "../../../components/ErrorDialog";
import { ErrorResponseDialog } from "../../../components/ErrorResponseDialog";
import { ICargo, ICreatorProfile, INftAsset, IProfile } from "../../../interfaces";
import { Utils } from "../../../utils";
import { NftCreatorAssetCard } from "./components/NftCreatorAssetCard";

export const NftCreatorPage = () => {
  const projectCode = 'NFT';
  const api = useApi(projectCode);
  const { t } = useTranslation();
  const params = useParams();
  const [isMounted, setMounted] = useState(false);
  const [publicProfile, setPUblicProfile] = useState<IProfile>();
  const [creatorProfile, setCreatorProfile] = useState<ICreatorProfile>();
  const [assets, setAssets] = useState<INftAsset[]>();
  const [expand, setExpand] = useState<boolean>(window.innerWidth > 768)

  useEffect(() => {
    if (!isMounted) {
      setMounted(true);
      if (params.memberNo) {
        api.getPublicProfile(params.memberNo, (cargo: ICargo) => {
          if (cargo.returnCode === '000000') {
            setPUblicProfile(cargo.info);
          }
        })
        api.getCreatorProfile(params.memberNo, (cargo: ICargo) => {
          if (cargo.returnCode === '000000') {
            setCreatorProfile(cargo.info);
          } else if (cargo.returnCode === '100016') {
            ErrorDialog({ title: "創作者尚未建立資料" })
          } else {
            ErrorResponseDialog(cargo, t)
          }
        })
      }
    }
  }, [api, isMounted, params.memberNo, t])
  
  useEffect(() => {
    if (publicProfile?.referralCode) {
      if (assets) return;
      api.getNftCreatorsAssets(publicProfile?.referralCode, (cargo: ICargo) => {
        if (cargo.returnCode === '000000') {
          setAssets(cargo.info);
        }
      })
    }
  }, [api, assets, publicProfile])

  return (
    <>
      <div className="w-100">
        <div className="createrImg">{creatorProfile?.bannerUrl && <img src={Utils().normalizeImagePath(creatorProfile.bannerUrl, projectCode)} alt={creatorProfile.bannerUrl} className="w-100" />}</div>
        <div className="creater-img ms-3 d-inline-flex">
          <img
            src={publicProfile?.avator 
              ? Utils().normalizeImagePath(publicProfile.avator, projectCode)
              : require('../../../assets/img/nocreater.png')} 
            alt=""
          />
        </div>
      </div>
      <div className="p-3">
        <div className="mx-auto" style={{ maxWidth: '1000px' }}>
          <div className="creater-title mb-3">{publicProfile?.nickname}</div>
          <div className="">創作者簡介</div>
          <div className="">
            {creatorProfile?.introduction}
          </div>
        </div>

        <div className="d-flex flex-column flex-md-row my-5">

          <div className="createrMenu text-lg mb-4 flex-shrink-0">
            <div className="d-flex justify-between fw-bolder cursor-pointer">
              <div>
              <span className="material-icons-outlined me-2" style={{ verticalAlign: 'sub' }}>category</span>類別
              </div>
              <span className="material-icons-outlined me-3" onClick={() => {
                setExpand(!expand)
              }}>{expand ? 'expand_less' : 'expand_more'}</span>
            </div>
            <hr className="me-3" />
            {
              expand && <div className="p-3">
                <div className="cursor-pointer mb-3">星河系列</div>
                <div className="cursor-pointer mb-3">萬象</div>
              </div>
            }
          </div>

          <div className="grid grid-cols-1 gap-y-10 gap-x-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
            {assets && assets.map((asset, index) => {
              return <NftCreatorAssetCard key={index} asset={asset} />
            })}
          </div>
        </div>
      </div>
    </>
  )
}